



























import { ActivityDto, LanguageDto } from "@/server/app.dtos";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from 'vuex-class';

@Component
export default class SendAlertsButtonComponent extends Vue {
  @Prop() activity!: ActivityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  isLoading: boolean = false;
  enableDialog:boolean = false;

  async onClick(index:number){
    console.log(index);
  }
}
